module.exports = __webpack_public_path__ + "static/media/TCS Logo.6ee70cbc.png";